import HouseSidingIcon from '@mui/icons-material/HouseSiding'
import { Button } from '@mui/material'
import styled from 'styled-components'
import theme from 'src/styles/theme'

export const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 5px 10px 0;
`

export const ButtonCreateDock = styled(Button)`
    color: ${theme.colors.white} !important;
    background-color:${theme.colors.darkBlue} !important;

    &:hover {
        background-color: ${theme.colors.darkBlueHover} !important;
    }

`
export const HouseIcon = styled(HouseSidingIcon)`
    color: ${theme.colors.white} !important;
    margin-right: 8px !important;
`
